import { Form, Modal, Select, Button } from 'antd'
import { getResultOptionSupportNeed, updateStatusSupportNeed, updateSupportNeed } from 'api/Project/supportneed'
import { getCookie } from 'helper/cookie'
import React, { useEffect, useState } from 'react'
import lang from 'lang/en'
import TextArea from 'antd/lib/input/TextArea'
import { CheckCircleOutlined } from '@ant-design/icons'

const initalState = {
  data: [],
  isLoading: true,
}

const ModalEdit = (props) => {
  const { modalState, setModalState, dataEdit, idEditPRJ, getListData, disableModal, dataProject, valueRole } = props
  const token = getCookie('access_token_admin')
  const companyIDUser = getCookie('companyId_project') //ถ้าuserไม่เคยกดไปที่ information เขาจะไม่มีคุกกี้ตัวนี้เลยเปลี่ยนไปใช่ api แทน
  const [form] = Form.useForm()
  const language = getCookie('lang')
  const word = lang[language]
  const [dataOption, setDataOption] = useState(initalState.data)
  const [valueStatus, setValueStatus] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [isSelectChanged, setIsSelectChanged] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false)
  const [optionStatus, setOptionStatus] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      id: 2,
      status_name: 'In Progress',
      key: 'inprogress'
    },
    {
      id: 3,
      status_name: 'Done',
      key: 'done'
    },
    {
      key: 4,
      status_name: 'Cancel',
      key: 'cancel',
    }
  ])

  const [optionStatus2, setOptionStatus2] = useState([
    {
      id: 1,
      status_name: 'Open',
      key: 'open',
    },
    {
      key: 4,
      status_name: 'Cancel',
      key: 'cancel',
    }
  ])

  const conditionStatus = () => {
    if ((valueRole.role_name === 'Project Member')) {
      // console.log('M')
      return (
        <Select
          className="Select Select-Custom"
          style={{ width: '100%' }}
          size="large"
          onChange={(e) => onChange(e)}
          defaultValue={dataEdit.support_status}
          disabled={disableModal}
        >
          {optionStatus2.map((item) => (
            <Option value={item.status_name}>{item.status_name}</Option>
          ))}
        </Select>
      )
    } else if (
      (valueRole.role_name === 'Project Leader') ||
      (valueRole.role_name === 'Project Sponsor') ||
      (valueRole.role_name === 'Project PMO')) {
      // console.log('L S P')
      return (
        <Select
          className="Select Select-Custom"
          style={{ width: '100%' }}
          size="large"
          onChange={(e) => onChange(e)}
          defaultValue={dataEdit.support_status}
          disabled={disableModal}
        >
          {optionStatus.map((item) => (
            <Option value={item.status_name}>{item.status_name}</Option>
          ))}
        </Select>
      )
    } else {
      // console.log('other')
      return (
        <Select
          className="Select Select-Custom"
          style={{ width: '100%' }}
          size="large"
          onChange={(e) => onChange(e)}
          defaultValue={dataEdit.support_status}
          disabled={disableModal}
        >
          {optionStatus2.map((item) => (
            <Option value={item.status_name}>{item.status_name}</Option>
          ))}
        </Select>
      )
    }
  }

  const setFieldValue = () => {
    form.setFieldsValue({
      type: dataEdit.support_type_id,
      remark: dataEdit.description,
    })
  }

  const getOption = async () => {
    getResultOptionSupportNeed({
      company_id: parseInt(dataProject.company_id),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataOption([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataOption(data)
        } else {
          setDataOption([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOption([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      setFieldValue()
      getOption()
    }
  }, [token, modalState])

  const onCancel = () => {
    setModalState(false)
    form.setFieldsValue({
      type: null,
      remark: null,
    })
  }

  const onChange = (value) => {
    setValueStatus(value)
    setIsSelectChanged(true);
  };

  const updateSupportNeedFunc = async (value) => {
    const dataInput = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: dataEdit.sprintflow_id,
      description: value.remark,
      support_type_id: value.type,
      taskinbox: 'N',
    }
    try {
      await updateSupportNeed({
        supportneed_id: dataEdit.id,
        params: dataInput,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getListData()
          setModalState(false)
          setModalSuccess(true)
          form.setFieldsValue({
            type: null,
            remark: null,
          })
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const updateStatusSupportNeedFunc = async () => {
    const dataStatus = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: dataEdit.sprintflow_id,
      support_status: valueStatus,
      auto_mail: 'y'
    }
    try {
      await updateStatusSupportNeed({
        supportneed_id: dataEdit.id,
        params: dataStatus,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          setIsSelectChanged(false)
          setModalState(false)
          setModalSuccess(true)
          getListData()
        } else {
          console.log(res.status)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onFinish = async (value) => {
    if (!isSelectChanged) {
      updateSupportNeedFunc(value)
    } else {
      await updateStatusSupportNeedFunc(),
        await updateSupportNeedFunc(value)
    }
  }


  return (
    <>
      <Modal
        visible={modalState}
        className="no-breadcrumb save-and-cancel-modal style-modal disable-page"
        maskClosable={false}
        onCancel={() => onCancel()}
        destroyOnClose={true}
        okText="Save"
        title="Support Need"
        onOk={form.submit}
        centered
        footer={[
          <>
            <Button key="ok" onClick={() => onCancel()}>
              Cancel
            </Button>
            <Button disabled={disableModal} key="ok" type="primary" onClick={form.submit}>
              Save
            </Button></>
        ]}
      >
        <Form form={form} onFinish={onFinish}>
          <div className="container-item-inner-modal">
            <h4 className="label">{word['addtask_supportneed_title_modal_type']}</h4>
            <Form.Item
              name="type"
              rules={[
                {
                  required: true,

                  message: word['addtask_supportneed_typesupportneed'],
                },
              ]}
            >
              <Select
                disabled={disableModal}
                className="Select Select-Custom"
                style={{ width: '100%' }}
                placeholder="Type "
                size="large"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {dataOption.map((item) => {
                  return <Option Option value={item.id} > {item.title_en}</Option>
                })}
              </Select>
            </Form.Item>

            <h4 className='label'>
              {word['addtask_supportneed_title_modal_remark']}
            </h4>
            <Form.Item
              name={'remark'}
              rules={[
                {
                  whitespace: true,
                  required: true,
                  message: word['addtask_supportneed_remark']
                }
              ]}>
              <TextArea
                disabled={disableModal}
                autoSize={{ minRows: 3, maxRows: 6 }}
                style={{ height: '50px', borderRadius: '5px' }} />
            </Form.Item>
            <h4 className="label">{word['Status']}</h4>
            {conditionStatus()}
          </div>
        </Form >
      </Modal >
      <Modal
        className='ModalStatusOption'
        visible={modalSuccess}
        maskClosable={false}
        destroyOnClose={true}
        onCancel={() => setModalSuccess(false)}
        centered
        footer={[
          <Button key="ok" type="primary" onClick={() => setModalSuccess(false)}>
            OK
          </Button>
        ]}
      >
        <CheckCircleOutlined style={{ fontSize: '100px', color: '#00964C', marginTop: '20px' }} />
        <p style={{ fontSize: '20px', fontWeight: 700, color: '#074E9F', marginTop: '20px' }} >Successfully</p>
        <h4 style={{ fontSize: '16px', marginTop: '20px' }}>
          Your support need has been saved and sent email
        </h4>
      </Modal >
    </>
  )
}

export default ModalEdit